/**
 * Sticky Add to Cart bar
 * - Appears only AFTER the visitor has scrolled past the main buy buttons (Add to cart + Buy now).
 * - Syncs the variant from the main form each time the bar appears, so it
 *   always adds exactly what the customer picked above.
 * - Adds to cart via the same AJAX endpoint Dawn uses, then refreshes whichever
 *   cart UI (cart-drawer or cart-notification) already exists on the page.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sticky-atc').forEach(initStickyAtc);
});

function initStickyAtc(bar) {
  var sectionId = bar.id.replace('StickyAtc-', '');
  var variantSelect = document.getElementById('StickyAtcVariant-' + sectionId);
  var variantText = document.getElementById('StickyAtcVariantText-' + sectionId);
  var qtyInput = document.getElementById('StickyAtcQty-' + sectionId);
  var priceEl = document.getElementById('StickyAtcPrice-' + sectionId);
  var submitBtn = document.getElementById('StickyAtcSubmit-' + sectionId);
  var submitText = submitBtn ? submitBtn.querySelector('.sticky-atc__submit-text') : null;
  var minusBtn = bar.querySelector('[data-qty-minus]');
  var plusBtn = bar.querySelector('[data-qty-plus]');

  var productFormId = bar.dataset.productFormId;
  var mainForm = productFormId
    ? document.getElementById(productFormId)
    : document.querySelector('product-form form');
  var mainButton = productFormId
    ? document.querySelector('#' + productFormId + ' button[type="submit"]')
    : document.querySelector('product-form form button[type="submit"]');

  /* ---------------- Variant helpers ---------------- */
  function applyVariant(opt) {
    var price = opt.getAttribute('data-price');
    var available = opt.getAttribute('data-available') === 'true';

    submitBtn.dataset.variantId = opt.value;
    submitBtn.disabled = !available;
    if (submitText) submitText.textContent = available ? 'Add to Cart' : 'Sold Out';
    if (priceEl && price) priceEl.textContent = formatMoney(price);
    if (variantText) variantText.textContent = opt.getAttribute('data-title') || opt.textContent.trim();
  }

  // Pull the currently selected variant from the main product form.
  function syncFromMain() {
    if (!variantSelect || !mainForm) return;
    var idInput = mainForm.querySelector('input[name="id"]');
    var id = idInput && idInput.value;
    if (!id || variantSelect.value === id) return;
    var opt = variantSelect.querySelector('option[value="' + id + '"]');
    if (!opt) return;
    variantSelect.value = id;
    applyVariant(opt);
  }

  /* ---------------- Show / hide ----------------
     The bar appears ONLY after the visitor has scrolled PAST the main buy buttons
     (Add to cart + Buy now). Before that, whether the buttons are still below the
     fold or on screen, the bar stays hidden. */
  function setVisible(show) {
    if (show) syncFromMain();
    bar.classList.toggle('sticky-atc--visible', show);
  }

  // Track the whole buy area, not just a single button
  var buyTarget =
    (mainForm && mainForm.closest('[data-pdp-buy-area]')) ||
    document.querySelector('[data-pdp-buy-area]') ||
    (mainButton && (mainButton.closest('product-form') || mainButton));

  function buyAreaIsAbove() {
    if (!buyTarget) return window.scrollY > 700;
    return buyTarget.getBoundingClientRect().bottom < 0;
  }

  if (buyTarget && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // off-screen AND above the viewport = the visitor scrolled past it
          setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(buyTarget);
  } else {
    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          setVisible(buyAreaIsAbove());
          ticking = false;
        });
      },
      { passive: true }
    );
    setVisible(buyAreaIsAbove());
  }

  /* ---------------- Quantity stepper (desktop) ---------------- */
  function setQty(value) {
    var next = Math.max(1, parseInt(value, 10) || 1);
    if (qtyInput) qtyInput.value = next;
  }
  if (minusBtn) {
    minusBtn.addEventListener('click', function () {
      setQty(parseInt(qtyInput.value, 10) - 1);
    });
  }
  if (plusBtn) {
    plusBtn.addEventListener('click', function () {
      setQty(parseInt(qtyInput.value, 10) + 1);
    });
  }
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      setQty(qtyInput.value);
    });
  }

  /* ---------------- Variant change (desktop select) ---------------- */
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      applyVariant(variantSelect.options[variantSelect.selectedIndex]);
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
      return Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    // Basic fallback if Shopify.formatMoney isn't available on this page
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }

  /* ---------------- Add to cart ---------------- */
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      if (submitBtn.disabled) return;

      var variantId = submitBtn.dataset.variantId;
      var quantity = qtyInput ? qtyInput.value : 1;

      submitBtn.classList.add('sticky-atc__submit--loading');
      submitBtn.disabled = true;

      var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          sections: getCartSectionIds(),
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (response) {
          if (response.status) {
            throw new Error(response.description || 'Could not add to cart');
          }
          renderCartSections(response);
          document.dispatchEvent(new CustomEvent('cart:update', { detail: response }));
          openCart();
          showAdded();
        })
        .catch(function (err) {
          console.error('Sticky add to cart:', err);
          if (submitText) {
            submitText.textContent = 'Try again';
            setTimeout(function () {
              submitText.textContent = 'Add to Cart';
            }, 2200);
          }
        })
        .finally(function () {
          submitBtn.classList.remove('sticky-atc__submit--loading');
          submitBtn.disabled = false;
        });
    });
  }

  // Brief success state: check icon on mobile, "Added ✓" text on desktop.
  function showAdded() {
    submitBtn.classList.add('sticky-atc__submit--added');
    if (submitText) submitText.textContent = 'Added ✓';
    setTimeout(function () {
      submitBtn.classList.remove('sticky-atc__submit--added');
      if (submitText) submitText.textContent = 'Add to Cart';
    }, 1600);
  }
}

function getCartSectionIds() {
  var ids = [];
  if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
  if (document.querySelector('cart-notification')) ids.push('cart-notification');
  if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
  return ids;
}

function renderCartSections(response) {
  if (!response || !response.sections) return;

  var drawer = document.querySelector('cart-drawer');
  var notification = document.querySelector('cart-notification');

  // Prefer Dawn's own components re-rendering themselves — keeps this in sync
  // with however your cart-drawer/cart-notification is actually built.
  if (drawer && typeof drawer.renderContents === 'function') {
    drawer.renderContents(response);
  } else if (notification && typeof notification.renderContents === 'function') {
    notification.renderContents(response);
  }

  // Always refresh the header cart bubble/count if present.
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble && response.sections['cart-icon-bubble']) {
    var parsed = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
    var newBubble = parsed.getElementById('cart-icon-bubble');
    if (newBubble) bubble.innerHTML = newBubble.innerHTML;
  }
}

function openCart() {
  var drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
  }
}